<!-- <img [src]="imggif" alt=""> -->
<div class="black-tlcd">
	<div [ngClass]="blackground ? 'black' : ''"></div>	
</div>
